import React, { Component } from 'react'

import { ADD_URL } from '../apiInfo';

import TestAddPage from './TestAddPage';
import SelectA from './SelectFromArray';
import FullScreeenSpinner from './FullScreeenSpinner';
import FullScreeenAlert from './FullScreenAlert';

export default class TestAddView extends Component {
	state = {
		test: {
			year: 2019,
			month: 1,
			day: 1,
			school: '',
			classYear: 1,
			className: '',
			subject: '',
			professor: '',
			images: [{ id: 0 }],
			description: '',
			nThInYear: '?'
		},

		optionsSchool: [],

		optionsProfessor: [],

		curImgId: 1,

		loadingState: ''
	}

	componentDidMount() {
		this.setState({
			optionsSchool: [
				{
					id: 'GSSRM',
					name: 'GSŠRM gimnazija',
					years: 4
				}
			],
		})

		//reads saved data from local storage
		const school = localStorage.getItem('school'); //school.id 
		const classYear = localStorage.getItem('year');

		//sets initial school and classYear, empty/1 if not saved
		this.setState((state) => ({
			test: {
				...state.test,
				school: school ? state.optionsSchool.find(school1 => school1.name === school).name : state.optionsSchool[0].name,
				classYear: classYear || 1,
			}
		}));
	}

	componentDidUpdate() {
		if (this.state.optionsProfessor.length === 0) {
			//get professor options from props if not already set
			if (this.props.professors && this.props.professors[0]) {

				const professor = this.props.selected.professor;
				const subject = this.props.selected.subject;

				this.setState(state => ({
					optionsProfessor: this.props.professors,
					test: {
						...state.test,
						professor: professor ? professor : this.props.professors[0].name,
						subject: subject ? subject : this.props.professors[0].subjects[0]
					}
				}));

			} else { //request onSearch to fetch professors data
				this.props.onSearch({ school: this.state.test.school, classYear: this.state.test.classYear, fromAdd: true })
			}
		}
	}















	//adding, moving and deleting images, each has {id: id, img: {image object}}

	addImg = (index) => {
		//default empty image, will show option to upload, id set to current id to set
		let newImg = {
			id: this.state.curImgId
		};

		//set img state to loading
		let newList = this.state.test.images;
		newList[index] = { id: this.state.test.images[index].id, loaded: false };

		//increase image id and add the updated list with empty image at the end
		this.setState((state) => ({
			curImgId: state.curImgId + 1,
			test: {
				...this.state.test,
				images: [...newList, newImg]
			}
		}));
	}

	loadImg = (index, img) => {
		//set img state to loaded and add actual image blob
		let newList = [...this.state.test.images];
		newList[index] = { id: newList[index].id, img, loaded: true };
		//console.log(index);

		this.setState({
			test: {
				...this.state.test,
				images: newList
			}
		});
	}

	moveImgLeft = (index) => {
		//switches image with selected index with the neighboring one in the array
		let newList = [...this.state.test.images];
		newList[index] = this.state.test.images[index - 1];
		newList[index - 1] = this.state.test.images[index];

		this.setState({
			test: {
				...this.state.test,
				images: newList
			}
		});
	}

	moveImgRight = (index) => {
		//switches image with selected index with the neighboring one in the array
		let newList = [...this.state.test.images];
		newList[index] = this.state.test.images[index + 1];
		newList[index + 1] = this.state.test.images[index];

		this.setState((state) => ({
			test: {
				...this.state.test,
				images: newList
			}
		}));
	}

	deleteImg = (index) => {
		//removes image with selected index from the array, if only one set the array to the initital state (with one empty image)
		let newList = [...this.state.test.images];
		if (this.state.test.images.length === 1) {
			newList = [{ id: this.state.curImgId }]
		} else {
			newList.splice(index, 1);
		}

		this.setState((state) => ({
			test: {
				...this.state.test,
				images: newList
			}
		}));
	}




	//called on selectBox changes
	handleChange = (name, value) => {
		console.log(name, value);
		const curTest = this.state.test;
		switch (name) {
			case 'school':
				//also sets the professor and subject to first option
				this.setState({
					test: {
						...curTest, school: value,
						professor: this.state.optionsProfessor[0].name,
						subject: this.state.optionsProfessor[0].subjects[0]
					}
				});
				break;
			case 'classYear':
				value = value.substring(0, 1);
				this.setState({
					test: { ...curTest, classYear: value }
				});
				break;
			case 'className':
				//also forces length to one
				value = value.substring(value.length - 1, value.length).toLowerCase();
				this.setState({
					test: { ...curTest, className: value }
				});
				break;
			case 'year':
				this.setState({
					test: { ...curTest, year: value }
				});
				break;
			case 'month':
				//translates from month name to month index
				const months = ['Januar', 'Februar', 'Marec', 'April', 'Maj', 'Junij', 'Julij', 'Avgust', 'September', 'Oktober', 'November', 'December'];
				value = months.indexOf(value) + 1;
				this.setState({
					test: { ...curTest, month: value }
				});
				break;
			case 'day':
				this.setState({
					test: { ...curTest, day: value }
				});
				break;
			case 'professor':
				//also sets subject to the first subject in the professor's list
				this.setState({
					test: {
						...curTest, professor: value,
						subject: this.state.optionsProfessor.find(prof => prof.name === value).subjects[0]
					}
				});
				break;
			case 'subject':
				this.setState({
					test: { ...curTest, subject: value }
				});
				break;
			case 'description':
				this.setState({
					test: { ...curTest, description: value }
				});
				break;
			case "nThInYear":
				this.setState({
					test: { ...curTest, nThInYear: value }
				});
				break;
			default:
		}
	}












	//sends all data from this.state.test to the server
	handleSubmit = (e) => {
		e.preventDefault();
		console.log("submited");

		let test = { ...this.state.test }
		delete test.images;

		let data = new FormData();

		//validates input, shows error message
		if (!test.school) {
			this.setState({
				loadingState: {
					error: true,
					message: 'Izbrati je treba šolo'
				}
			})
			return;
		}
		if (!test.className) {
			this.setState({
				loadingState: {
					error: true,
					message: 'Vnesti je treba razred oz. paralelko (a, b, c...)'
				}
			})
			return;
		}
		if (!test.subject || !test.professor) {
			this.setState({
				loadingState: {
					error: true,
					message: 'Izbrati je treba profesorja in predmet'
				}
			})
			return;
		}

		//extracts image objects from array of imgs, remove empty img object at the end
		let images = this.state.test.images.map(img => img.img);
		images = images.splice(0, images.length - 1);

		//validates image data
		if (images.length === 0) {
			this.setState({
				loadingState: {
					error: true,
					message: 'Test mora vsebovati vsaj eno stran'
				}
			})
			return;
		}
		if (this.state.test.images.some(img => img.loaded === false)) {
			this.setState({
				loadingState: {
					error: true,
					message: 'Nekatere slike še niso pripravljene za prenos, počakajte'
				}
			})
			return;
		}
		if (images.length > 10) {
			this.setState({
				loadingState: {
					error: true,
					message: 'Test lahko vsebuje največ 10 strani'
				}
			})
			return;
		}

		//appends images to formData
		images.forEach((img, i) => {
			console.log(img, i);
			data.append(`file${i}`, img);
		})

		data.append('year', test.year);
		data.append('month', test.month);
		data.append('day', test.day);
		data.append('school', test.school);
		data.append('classYear', test.classYear);
		data.append('className', test.className);
		data.append('professor', test.professor);
		data.append('subject', test.subject);
		data.append('description', test.description);
		data.append('nThInYear', test.nThInYear);

		this.setState({ loadingState: 'Loading' });
		fetch(ADD_URL, {
			method: 'POST',
			body: data
		}).then((response) => response.json())
			.then((response) => {
				if (response.error) { //in case of error in the server, will cause a pop-up
					this.setState({ loadingState: { error: true, message: response.errorMessage } });
				} else { //redirect to the new test page '/test/:id'
					this.setState({ loadingState: '' });
					this.props.history.push('/test/' + response.id);
				}
			})
			.catch(response => this.setState({
				loadingState: { error: true, message: 'Prišlo je do napake, poskusite ponovno' }
			}));
	}


	render() {
		const { test } = this.state;
		return (

			<div className="container main" >
				<div className="row">
					<div className="col-12">
						<div className="card card-colored">

							<form className="card-body text-center" onSubmit={this.handleSubmit} >
								<h1 className="h1">Dodaj nov test</h1>
								<div className="row">
									<div className="col-12 col-md-6">

										<div className="form-group">
											<label htmlFor="school">Šola </label>
											<SelectA value={this.state.test.school}
												name="school"
												options={() => this.state.optionsSchool.map(school => school.name)}
												onChange={this.handleChange}
											/>
										</div>
										<div className="form-group class-select">
											<label htmlFor="classYear">Letnik </label>
											<div>
												<SelectA value={`${this.state.test.classYear}. letnik`}
													name="classYear"
													options={() => [...Array(this.state.optionsSchool.find(school => school.name === this.state.test.school).years)].map((_, i) => `${i + 1}. letnik`)}
													onChange={this.handleChange}
													iff={this.state.test.school}
													classExtra="big"
												/>
												<input type="text" className="form-control small" value={this.state.test.className} onChange={(e) => this.handleChange('className', e.target.value)} name="className" placeholder="a, b..." />
											</div>
										</div>

										<div className="form-group date-select">
											<label htmlFor="year">Datum </label>
											<div>
												<select className="form-control year"
													name="year"
													onChange={(e) => this.handleChange('year', e.target.value)}
													value={this.state.test.year} >
													{[...Array(20)].map((m, i) => (
														<option key={i} >
															{i - 19 + 2019}
														</option>

													))}
												</select>
												<select className="form-control month" name="month" onChange={(e) => this.handleChange('month', e.target.value)}>
													{['Januar', 'Februar', 'Marec', 'April', 'Maj', 'Junij', 'Julij', 'Avgust', 'September', 'Oktober', 'November', 'December'].map((m, i) => (
														<option key={i} >
															{m}
														</option>
													))}
												</select>
												<select className="form-control day" name="day" onChange={(e) => this.handleChange('day', e.target.value)}>
													{[...Array(31)].map((m, i) => (
														<option key={i} >
															{i + 1}
														</option>
													))}
												</select>
											</div>
										</div>

									</div>


									<div className="col-12 col-md-6">

										<div className="form-group">
											<label htmlFor="professor">Profesor </label>
											<SelectA value={this.state.test.professor}
												name="professor"
												options={() => this.state.optionsProfessor.map(prof => prof.name)}
												onChange={this.handleChange}
												iff={this.state.optionsProfessor}
											/>
										</div>

										<div className="form-group">
											<label htmlFor="subject">Predmet </label>
											<SelectA value={this.state.test.subject}
												name="subject"
												options={() => this.state.optionsProfessor.find(prof => prof.name === this.state.test.professor).subjects}
												onChange={this.handleChange}
												iff={this.state.optionsProfessor && this.state.test.professor}
											/>
										</div>

										<div className="form-group">
											<label htmlFor="description">Opis</label>
											<textarea type="text" className="form-control" name="description" rows="2" value={this.state.test.description} onChange={(e) => this.handleChange('description', e.target.value)} />
										</div>

										{/* <div className="form-group withFloat">
											<label htmlFor="nThInYear">Zaporedna št. testa</label>
											<select className="form-control nThInYear" name="nThInYear" value={this.state.test.nThInYear} onChange={(e) => this.handleChange('nThInYear', e.target.value)}>
												{['?', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(m => (
													<option key={m} >
														{m}
													</option>
												))}
											</select>
										</div>*/}

									</div>
									<div className="col-12">
										<button className="btn btn-outline-primary btn-block" type="submit" value="Naloži"><i className="fas fa-cloud-upload-alt"></i> Dodaj</button>
									</div>
								</div>
							</form>

						</div>
					</div>
				</div>


				<div className="row my-4 img-row">

					{[...test.images].map((image, index) => (
						< TestAddPage
							image_id={image.id}
							index={index}
							key={image.id}
							onAdd={this.addImg}
							first={index === 0}
							last={index >= test.images.length - 2}
							loaded={image.loaded}

							onLoad={this.loadImg}
							moveLeft={this.moveImgLeft}
							moveRight={this.moveImgRight}
							delete={this.deleteImg}
						/>
					))}

				</div>

				{this.state.loadingState === 'Loading' && <FullScreeenSpinner />}
				{this.state.loadingState.error && <FullScreeenAlert
					message={this.state.loadingState.message}
					buttonText="OK"
					onExit={() => this.setState({ loadingState: '' })}
				/>}
			</div>

		)
	}
}
